/* ========================================================================
    Module: Util
 ========================================================================== */
/**
 * HTML エスケープを行う
 *
 * @param {T} string
 * @returns {string | T}
 */
const esc_html = <T>(string: T): string | T => {
    if (typeof string !== "string") {
        return string;
    }

    return string.replace(/[&'`"<>]/g, (match: string): string => {
        const result = {
            "&": "&amp;",
            "'": "&#x27;",
            "`": "&#x60;",
            '"': "&quot;",
            "<": "&lt;",
            ">": "&gt;",
        }[match];

        return result ?? string;
    });
};

export { esc_html };
